module.exports = __webpack_public_path__ + "static/heroOlympo36-e59213c5e619c3b6e042730a63b5e121.png";